package com.nonopn.icons

import androidx.compose.material.icons.Icons
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

public val Icons.Rounded.Administrator: ImageVector
    get() {
        if (_administrator != null) {
            return _administrator!!
        }
        _administrator =
            Builder(
                name = "Administrator",
                defaultWidth = 48.0.dp,
                defaultHeight = 48.0.dp,
                viewportWidth = 48.0f,
                viewportHeight = 48.0f,
            )
                .apply {
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(43.281f, 27.487f)
                        verticalLineTo(8.115f)
                        curveTo(33.105f, 7.944f, 24.292f, 0.008f, 24.292f, 0.008f)
                        reflectiveCurveTo(15.479f, 7.944f, 5.303f, 8.115f)
                        horizontalLineTo(4.719f)
                        verticalLineToRelative(18.897f)
                        curveToRelative(0.0f, 0.803f, 0.186f, 2.161f, 0.187f, 2.165f)
                        curveToRelative(0.604f, 3.032f, 3.658f, 11.327f, 19.091f, 18.794f)
                        curveToRelative(0.001f, 0.007f, 0.003f, 0.014f, 0.004f, 0.021f)
                        curveToRelative(0.006f, -0.004f, 0.012f, -0.006f, 0.019f, -0.009f)
                        curveToRelative(0.006f, 0.003f, 0.012f, 0.005f, 0.018f, 0.009f)
                        curveToRelative(0.002f, -0.007f, 0.003f, -0.014f, 0.004f, -0.021f)
                        curveToRelative(15.244f, -7.375f, 18.408f, -15.556f, 19.065f, -18.678f)
                        curveTo(43.223f, 28.742f, 43.281f, 27.487f, 43.281f, 27.487f)
                        close()
                    }
                }
                .build()
        return _administrator!!
    }

private var _administrator: ImageVector? = null
